import { render, staticRenderFns } from "./logmange.vue?vue&type=template&id=f6d57bb4&scoped=true"
import script from "./logmange.vue?vue&type=script&lang=js"
export * from "./logmange.vue?vue&type=script&lang=js"
import style0 from "./logmange.vue?vue&type=style&index=0&id=f6d57bb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d57bb4",
  null
  
)

export default component.exports